/**
 * HLF A+ Content — Interactive Behaviors
 * Version: 5.0.0
 *
 * Handles:
 *  1. FAQ accordion open/close with single-open constraint
 *  2. Sticky sub-nav active state via IntersectionObserver
 *  3. Smooth-scroll click handler for sub-nav links
 */

document.addEventListener('DOMContentLoaded', () => {
  /* ------------------------------------------------------------------ */
  /* 1. FAQ ACCORDION                                                   */
  /* ------------------------------------------------------------------ */
  const faqItems = document.querySelectorAll('.hlf-aplus-faq-item');

  faqItems.forEach(item => {
    const trigger = item.querySelector('.hlf-aplus-faq-trigger');
    const panel = item.querySelector('.hlf-aplus-faq-panel');

    if (!trigger || !panel) return;

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const isActive = item.classList.contains('active');

      // Close other accordions
      faqItems.forEach(otherItem => {
        if (otherItem !== item && otherItem.classList.contains('active')) {
          otherItem.classList.remove('active');
          const otherTrigger = otherItem.querySelector('.hlf-aplus-faq-trigger');
          const otherPanel = otherItem.querySelector('.hlf-aplus-faq-panel');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.style.maxHeight = '0px';
        }
      });

      // Toggle current accordion
      if (isActive) {
        item.classList.remove('active');
        trigger.setAttribute('aria-expanded', 'false');
        panel.style.maxHeight = '0px';
      } else {
        item.classList.add('active');
        trigger.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  /* ------------------------------------------------------------------ */
  /* 2. STICKY SUB-NAV — Scroll Highlight via IntersectionObserver      */
  /* ------------------------------------------------------------------ */
  const navLinks = document.querySelectorAll('.hlf-aplus-nav-link');
  const modules = document.querySelectorAll('.hlf-aplus-module');
  const navContainer = document.querySelector('.hlf-aplus-nav');

  let isScrollingProgrammatically = false;
  let scrollTimeout = null;

  if (navLinks.length > 0 && modules.length > 0) {
    // Helper — horizontally center a link inside the scrollable nav
    const centerNavLink = (link) => {
      if (!navContainer) return;
      const containerWidth = navContainer.clientWidth;
      const linkLeft = link.offsetLeft;
      const linkWidth = link.clientWidth;
      navContainer.scrollTo({
        left: linkLeft - (containerWidth / 2) + (linkWidth / 2),
        behavior: 'smooth'
      });
    };

    /* 2a. Smooth-scroll click handler */
    navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href');
        const targetEl = document.querySelector(targetId);

        if (targetEl) {
          isScrollingProgrammatically = true;
          if (scrollTimeout) clearTimeout(scrollTimeout);

          // Update active class immediately on click
          navLinks.forEach(l => l.classList.remove('active'));
          link.classList.add('active');
          centerNavLink(link);

          const offsetTop = targetEl.getBoundingClientRect().top + window.scrollY - 65;
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });

          // Unlock observer after smooth scroll completes
          scrollTimeout = setTimeout(() => {
            isScrollingProgrammatically = false;
          }, 800);
        }
      });
    });

    /* 2b. IntersectionObserver to update active class on scroll */
    const observerOptions = {
      root: null,
      rootMargin: '-25% 0px -65% 0px',
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      if (isScrollingProgrammatically) return;

      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.getAttribute('id');
          navLinks.forEach(link => {
            if (link.getAttribute('href') === `#${id}`) {
              link.classList.add('active');
              centerNavLink(link);
            } else {
              link.classList.remove('active');
            }
          });
        }
      });
    }, observerOptions);

    modules.forEach(m => observer.observe(m));
  }
});
